import React, { useEffect, useRef, useState } from "react";
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ChevronDown, ChevronLeft, ChevronRight } from 'react-feather'
import Loader from "../component/Loader";
import ProfileService from "../services/Profile";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import { useSelector } from "react-redux";
import { formatNumberWithCommas } from "../constants/commonFunction";
import ReactPaginate from "react-paginate";
import Accordion from 'react-bootstrap/Accordion';
import NoData from '../component/NoData';

const ReedemablePoints = () => {
    const tokens =  useSelector(
        state => state.userTypeSlice.token,
      );
    const [isSelectedItem, setIsSelectedItem] = useState('')
    const [isPointStatementData, setIsPointStatementData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAllTab, setIsAllTab] = useState(true);
    const [isDebitTab, setIsDebitTab] = useState(false);
    const [isTdsTab, setIsTdsTab] = useState(false);
    const [isCreditTab, setIsisCreditTab] = useState(false);
    const [isDebitData, setIsDebitData] = useState([]);
    const [isCreditData, setIsCreditData] = useState([]);
    const [isTdsData, setIsTdsData] = useState([]);
    const [visibleItemCount, setVisibleItemCount] = useState(15);
    const [visibleItemCountDebit, setVisibleItemCountDebit] = useState(15);
    const [visibleItemCountCredit, setVisibleItemCountCredit] = useState(15);
    const [visibleItemCountAll, setVisibleItemCountAll] = useState(15);
    const [currentTab, setCurrentTab] = useState('all');
    const [tranList, setTranList] = useState([]);
    const [creditList, setCreditList] = useState([]);
    const [debitList, setDebitList] = useState([]);
    const [tdsList, setTdsList] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [limit, setlimit] = useState(50);
    const [hasMore, setHasMore] = useState(true);
    const isFirstTabRender = useRef(true);

    useEffect(() => {
        // const MyPointsDataFetch = async () => {
        //     try {
        //         setLoading(true)
        //         const token = localStorage.getItem('access_token');
        //         const MyPointsResponse = await ProfileService.getAvailablePoints(token)
        //         setLoading(false)
        //         if (MyPointsResponse.success == true) {

        //             const PointsSpentData = MyPointsResponse.response.pointDetails.trnasc_list
        //             setIsPointStatementData(MyPointsResponse.response.pointDetails.trnasc_list)
        //             const creditData = PointsSpentData.filter(item =>
        //                 item.transaction_desc === "Recredit" || item.transaction_desc === "Accrual"
        //             );
        //             setIsCreditData(creditData)
        //             const debitData = PointsSpentData.filter(item =>
        //                 item.transaction_desc === "Miscredit" || item.transaction_desc === "Redemption"
        //             );
        //             setIsDebitData(debitData);
        //             const tdsData = PointsSpentData.filter(item => item.transaction_desc === "Miscredit");
        //             setIsTdsData(tdsData);
                    
        //         }
        //     }
        //     catch (error) {
        //         console.error("MyPointsResponse")
        //         setLoading(false)
        //     }

        // }
        // MyPointsDataFetch()
        if(tokens.access)
            getPoints(tokens.access, "", "")
    }, [tokens])
    useEffect(() => {
        if (isFirstTabRender.current) {
            isFirstTabRender.current = false;
            return;
        }
        setPageNo(1);
        getPoints(tokens.access, "", "");
        setHasMore(true)
      }, [currentTab]);

    useEffect(() => {
        if(pageNo > 1)
            getPoints(tokens.access, "", "");
    }, [pageNo])

    async function getPoints(token, from_date, to_date) {
        const trans_type =
          currentTab == 'all'
            ? ''
            : currentTab == 'credit'
            ? 'C'
            : currentTab == 'tds_deduct'
            ? 'DM'
            : 'D';
        const trans_desc = currentTab == 'tds_deduct' ? 'Miscredit' : '';
        setLoading(true);

        ProfileService.getAvailablePointsRedeemable(
          from_date,
          to_date,
          trans_type,
          trans_desc,
          limit,
          pageNo,
        )
          .then(res => {
            if (res.success === true) {
              setLoading(false);

              const trnasc_list = res.response.pointDetails.trnasc_list;
              if (trnasc_list.length == 0) {
                setHasMore(false);
              } else {
                if (pageNo == 1) {
                  setTranList([]);
                  setCreditList([]);
                  setDebitList([]);
                  setTdsList([]);
                }
                setTranList(p => [...p, ...trnasc_list]);
                const recreditItems = trnasc_list.filter(
                  item =>
                    item.transaction_desc === 'Recredit' ||
                    item.transaction_desc === 'Accrual' ||
                    item.transaction_desc === 'Bonus',
                );
                setCreditList(p => [...p, ...recreditItems]);
                const debitList = trnasc_list.filter(
                  item =>
                    item.transaction_desc === 'Redemption' ||
                    item.transaction_desc === 'Miscredit',
                );
                setDebitList(p => [...p, ...debitList]);
                const tdsList = trnasc_list.filter(
                  item => item.transaction_desc === 'Miscredit' ,
                );
                setTdsList(p => [...p, ...tdsList]);
              }
            } else {
              setLoading(false);
              setTranList([]);
              setCreditList([]);
              setDebitList([]);
              setTdsList([]);
            }

          })
          .catch(err => {
            setLoading(false);
          });
      };

    const handleAccordionOpen = (id) => {

        if (id == isSelectedItem) {
            setIsSelectedItem('')
        }
        else {
            setIsSelectedItem(id)
        }

    }
    const handleTabClick = (tabName) => {
        setIsAllTab(tabName === 'all');
        setIsDebitTab(tabName === 'debit')
        setIsTdsTab(tabName === 'tds')
        setIsisCreditTab(tabName === 'credit')
    };
    const handleShowMore = () => {
        setVisibleItemCount(prevCount => prevCount + 10);
    };
    const handleDebitShowMore = () => {
        setVisibleItemCountDebit(prevCount => prevCount + 10);
    }
    const handleShowMoreAll = () => {
        setVisibleItemCountAll(prevCount => prevCount + 10);
    }
    const handleCreditShowMore = () => {
        setVisibleItemCountCredit(prevCount => prevCount + 10)
    }
    const handlePageClick = (selectedPage) => {
        setPageNo(p => p + 1); // Adding 1 to match page number
    };
    const currentTabList = isAllTab ? tranList : isCreditTab ? creditList : isDebitTab ? debitList : tdsList;
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion pageTitle="Redeemable Points" currentPageName="Redeemable Points" />
            <section className='padTop50'>
                
                    <Container>
                        <Row>
                            <Col>
                                <div className='notificationTabList ad-tab-link'>
                                    <ul>
                                        <li onClick={() => handleTabClick('all')} className={isAllTab ? 'active' : ''}>
                                            <Link>All</Link>
                                        </li>
                                        <li onClick={() => handleTabClick('credit')} className={isCreditTab ? 'active' : ''}>
                                            <Link>Credit</Link>
                                        </li>
                                        <li onClick={() => handleTabClick('debit')} className={isDebitTab ? 'active' : ''}>
                                            <Link>Debit</Link>
                                        </li>
                                        <li onClick={() => handleTabClick('tds')} className={isTdsTab ? 'active' : ''}>
                                            <Link>TDS Deduct</Link>
                                        </li>
                                    </ul>
                                </div>
                                {!loading && currentTabList.length === 0 ? (
                                    <NoData />
                                ) : (
                                <div className='userInfoBox py-0'>



                                        {isAllTab &&
                                            <Row>
                                                {tranList.map((item, index) => {
                                                    const pointRedemptionData = item.transaction_desc === "Accrual" || item.transaction_desc === "Recredit" || item.transaction_desc === "Bonus" ? <p className="greenTxt mb-0"> + {formatNumberWithCommas(item.reward_points)}</p> : <p className="redTxt mb-0"> - {formatNumberWithCommas(item.reward_points)}</p>

                                                    const dateTime = new Date(item?.created_at);
                                                    const formattedDate = dateTime.toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'long',
                                                        year: 'numeric',
                                                        timeZone: 'UTC'
                                                    });
                                                    const formattedTime = dateTime.toLocaleTimeString('en-US', {
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                        timeZone: 'UTC'
                                                    }).replace(' ', '');
                                                    const formattedDateTime = `${formattedDate} ${formattedTime}`;

                                                    return (
                                                        <Col xs={12} key={index}>
                                                            <Accordion defaultActiveKey="0" className="mb-3">
                                                            <Accordion.Item eventKey={index} key={index}>
                                                            <Accordion.Header>
                                                            <div className='pointsSpentBlock ad-acc'>
                                                                    
                                                                <div className='pointsSpentAmount col text-right'>
                                                                   <p>{`${item.transaction_desc}${item.comment ? ` (${item.comment})` : ''}`}</p>
                                                                    <span>{formattedDateTime}</span>
                                                                </div>
                                                                <div className='pointsSpentAmountNo'>
                                                                 {pointRedemptionData}
                                                                </div>
                                                                
                                                                
                                                                
                                                                {/* <div className='pointsSpentAmountViewMoreBtn' onClick={() => { handleAccordionOpen(item.id) }}>

                                                                    <ChevronDown />
                                                                </div> */}
                                                            </div>
                                                            </Accordion.Header>
                                                            {/* {isSelectedItem == item.id && ( */}
                                                            <Accordion.Body>
                                                                <div className='pointsSpentAmountViewMoreWrap bg-white'>                                                                        
                                                                    <table className="table table-bordered">
                                                                        <tr>
                                                                            <th colSpan={2}>Points were credited using</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Id</td>
                                                                            <td>{item.order_id}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Item</td>
                                                                            <td>{item.order_item_name}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Points</td>
                                                                            <td className="pointsValueLeftAlign">{pointRedemptionData}</td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                                </Accordion.Body>
                                                            {/* // )} */}
                                                            </Accordion.Item>
                                                            </Accordion>
                                                        </Col>
                                                    )
                                                })}
                                                {visibleItemCountAll < isPointStatementData.length && (
                                                   <Row className="justify-content-center my-4">
                                                    <Col xs={12} lg={3}>
                                                        <PrimaryGradientButton onClick={handleShowMoreAll} buttonText='Show More' />

                                                    </Col>
                                                    </Row>

                                                )}

                                            </Row>
                                        }
                                        {/*Credit*/}
                                        {isCreditTab &&
                                            <Row>
                                                {creditList.map((item, index) => {
                                                    const dateTime = new Date(item.created_at);
                                                    const formattedDate = dateTime.toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'long',
                                                        day: 'numeric',
                                                        timeZone: 'UTC',
                                                    });
                                                    const formattedTime = dateTime.toLocaleTimeString('en-US', {
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                        timeZone: 'UTC',
                                                    }).replace(' ', '');
                                                    const formattedDateTime = `${formattedDate}, ${formattedTime}`;
                                                    return (
                                                        <Col xs={12} key={index}>
                                                            <Accordion defaultActiveKey="0" className="mb-3">
                                                            <Accordion.Item eventKey={index} key={index}>
                                                            <Accordion.Header>
                                                            <div className='pointsSpentBlock ad-acc'>
                                                                {/* <div className='pointsSpentBlock'> */}

                                                                {/* <div className='pointsSpentTitle'> */}
                                                                <div className='pointsSpentAmount col text-right'>
                                                                    <p>{`${item.transaction_desc}${item.comment ? ` (${item.comment})` : ''}`}</p>
                                                                    <span>{formattedDateTime}</span>
                                                                </div>
                                                                <div className='pointsSpentAmountNo'>
                                                                    <p className="greenTxt mb-0"> + {formatNumberWithCommas(item.reward_points)}</p>
                                                                </div>
                                                                {/* <div className='pointsSpentAmountViewMoreBtn' onClick={() => { handleAccordionOpen(item.id) }}>
                                                                    <ChevronDown />
                                                                </div> */}
                                                            </div>
                                                            </Accordion.Header>
                                                            
                                                                    <Accordion.Body>
                                                                <div className='pointsSpentAmountViewMoreWrap bg-white'>
                                                                    <table className="table table-bordered">

                                                                        <tr>
                                                                            <th colSpan={2}>Points were credited using</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Id</td>
                                                                            <td>{item.order_id}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Item</td>
                                                                            <td>{item.order_item_name}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Points</td>
                                                                            <td className="pointsValueLeftAlign"><div className="greenTxt">
                                                                                + {formatNumberWithCommas(item.reward_points)}</div>
                                                                            </td>
                                                                        </tr>
                                                                    </table>


                                                                </div>
                                                                </Accordion.Body>
                                                                </Accordion.Item>
                                                                </Accordion>
                                                                </Col>
                                                            
                                                            

                                                      
                                                    )
                                                })}
                                                {visibleItemCountDebit < isCreditData.length && (
                                                    <Row className="justify-content-center my-4">
                                                    <Col xs={12} lg={3}>
                                                        <PrimaryGradientButton onClick={handleCreditShowMore} buttonText='Show More' />

                                                    </Col>
                                                    </Row>

                                                )}

                                            </Row>
                                            }
                                        {/* //Debit */}
                                        {isDebitTab &&
                                            <Row>
                                                {debitList.map((item, index) => {
                                                    const dateTime = new Date(item.created_at);
                                                    const formattedDate = dateTime.toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'long',
                                                        day: 'numeric',
                                                        timeZone: 'UTC',
                                                    });
                                                    const formattedTime = dateTime.toLocaleTimeString('en-US', {
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                        timeZone: 'UTC',
                                                    }).replace(' ', '');
                                                    const formattedDateTime = `${formattedDate}, ${formattedTime}`;
                                                    return (
                                                        <Col xs={12} key={index}>
                                                            <Accordion defaultActiveKey="0" className="mb-3">
                                                            <Accordion.Item eventKey={index} key={index}>
                                                            <Accordion.Header>
                                                            {/* <div className='pointsSpentBlock'> */}
                                                            <div className='pointsSpentBlock ad-acc'>
                                                                <div className='pointsSpentAmount col text-right pointsSpentAmountg'>

                                                                    <p >{`${item.transaction_desc}${item.comment ? ` (${item.comment})` : ''}`}</p>
                                                                    <span >{formattedDateTime}</span>
                                                                </div>
                                                                <div className='pointsSpentAmountNo '>
                                                                    <p className="redTxt mb-0 "> - {formatNumberWithCommas(item.reward_points)}</p>
                                                                </div>
                                                                {/* <div className='pointsSpentAmountViewMoreBtn' onClick={() => { handleAccordionOpen(item.id) }}>
                                                                    <ChevronDown />
                                                                </div> */}
                                                            </div>
                                                            </Accordion.Header>
                                                                <Accordion.Body>
                                                                <div className='pointsSpentAmountViewMoreWrap bg-white'>

                                                                    <table className="table table-bordered">
                                                                        <tr>
                                                                            <th colSpan={2} >Points were debited using</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Id</td>
                                                                            <td>{item.order_id}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Item</td>
                                                                            <td>{item.order_item_name}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Points</td>
                                                                            <td className="pointsValueLeftAlign"><div className="redTxt"> - {formatNumberWithCommas(item.reward_points)}</div></td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                </Accordion.Body>
                                                                </Accordion.Item>
                                                                </Accordion>
                                                        </Col>
                                                    )
                                                })}

                                                {visibleItemCountDebit < isDebitData.length && (
                                                   <Row className="justify-content-center my-4">
                                                    <Col xs={12} lg={3}>
                                                        <PrimaryGradientButton onClick={handleDebitShowMore} buttonText='Show More' />

                                                    </Col>
                                                    </Row>

                                                )}

                                            </Row>

                                        }
                                        {/* //TDS */}
                                        {isTdsTab &&
                                            <Row>
                                                {tdsList.map((item, index) => {
                                                    const dateTime = new Date(item.created_at);
                                                    const formattedDate = dateTime.toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'long',
                                                        day: 'numeric',
                                                        timeZone: 'UTC',
                                                    });
                                                    const formattedTime = dateTime.toLocaleTimeString('en-US', {
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                        timeZone: 'UTC',
                                                    }).replace(' ', '');
                                                    const formattedDateTime = `${formattedDate}, ${formattedTime}`;
                                                    return (
                                                        <Col xs={12} key={index}>
                                                            <Accordion defaultActiveKey="0" className="mb-3">
                                                            <Accordion.Item eventKey={index} key={index}>
                                                            <Accordion.Header>
                                                            <div className='pointsSpentBlock ad-acc'>
                                                                <div className='pointsSpentAmount col text-right '>
                                                                    <p>{item.transaction_desc}</p>
                                                                    <span>{formattedDateTime}</span>
                                                                </div>
                                                                <div className='pointsSpentAmountNo'>
                                                                    <p className="redTxt mb-0"> - {formatNumberWithCommas(item.reward_points)}</p>
                                                                </div>
                                                                {/* <div className='pointsSpentAmountViewMoreBtn' onClick={() => { handleAccordionOpen(item.id) }}>
                                                                    <ChevronDown />
                                                                </div> */}
                                                            </div>
                                                            </Accordion.Header>
                                                                <Accordion.Body>
                                                                <div className='pointsSpentAmountViewMoreWrap bg-white'>

                                                                    <table className="table table-bordered">
                                                                        <tr>
                                                                            <th colSpan={3}>Points were credited using</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Order Id</td>

                                                                            <td>Available Points</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{item.tds_order_id}</td>
                                                                            <td> <div className="redTxt"> - {formatNumberWithCommas(item.reward_points)}</div></td>

                                                                        </tr>
                                                                    </table>

                                                                    {/* <p>Points were credited using</p>
                                                                    <div className="orderDetailsSmallText">
                                                                        <p>Order Id</p>
                                                                        <p>{item.tds_order_id}</p>
                                                                    </div>
                                                                    
                                                                    <div className="orderDetailsSmallText">
                                                                        <p>Available Points</p>
                                                                        <p className="redTxt"> - {item.reward_points}</p>
                                                                    </div> */}

                                                                </div>
                                                                </Accordion.Body>
                                                                </Accordion.Item>
                                                                </Accordion>
                                                        </Col>
                                                    )
                                                })}
                                                {visibleItemCount < isTdsData.length && (
                                                    <Row className="justify-content-center my-4">
                                                    <Col xs={12} lg={3}>
                                                        <PrimaryGradientButton onClick={handleShowMore} buttonText='Show More' />

                                                    </Col>
                                                    </Row>

                                                )}
                                            </Row>

                                        }

                                </div>
                                )}
                            </Col>
                        </Row>
                        {currentTabList.length > 15 && hasMore &&
                        <Row className="justify-content-center my-4">
                            <Col xs={12} lg={3}>
                                <PrimaryGradientButton onClick={handlePageClick} buttonText='Show More' />

                            </Col>
                            </Row>
                        }
                    </Container>
                
            </section>
        </>
    )
}

export default ReedemablePoints